import { Action, PayloadAction, createSlice } from '@reduxjs/toolkit';
import { useAppSelector } from '../store-hooks';
import { resetRedux } from '../actions/shared-actions';
export interface SelectedMemberState {
  memberId: string | null;
  teamMemberId: string | null;
}

const initialState: SelectedMemberState = {
  memberId: null,
  teamMemberId: null,
};

// THUNKS/ACTIONS ==============================================================
// INITIAL STATE ===============================================================

// SLICE =======================================================================
export const selectedMemberSlice = createSlice({
  name: 'selectedMember',
  initialState: initialState,
  reducers: {
    selectMember: (
      state: SelectedMemberState,
      action: PayloadAction<string>
    ) => {
      state.memberId = action.payload;
    },
    deselectMember: (state: SelectedMemberState, _action: Action) => {
      state.memberId = null;
    },
    selectTeamMember: (
      state: SelectedMemberState,
      action: PayloadAction<string>
    ) => {
      state.teamMemberId = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetRedux, state => {
      state = { ...initialState };
      return state;
    });
  },
});

// REDUCER =====================================================================
export const selectedMemberReducer = selectedMemberSlice.reducer;

// SELECTORS ===================================================================
export const { selectMember, deselectMember, selectTeamMember } =
  selectedMemberSlice.actions;

export const selectSelectedMemberId = state =>
  (state as { selectedMember: SelectedMemberState })?.selectedMember?.memberId;

export const selectSelectedTeamMemberId = state =>
  (state as { selectedMember: SelectedMemberState })?.selectedMember
    .teamMemberId;

// EXPORT HELPER ===============================================================
export const selectedMemberSelectors = {
  useSelectSelectedTeamMemberId: () =>
    useAppSelector(selectSelectedTeamMemberId),
  useSelectSelectedMemberId: () => useAppSelector(selectSelectedMemberId),
};

// EFFECTS =====================================================================
// WEBSOCKET ACTIONS ===========================================================
